const initialState = {
  pending: null,

  recorderId: null,
  recorderName: null,

  id: null,
  name: null,
  dtCreated: null,
  dtUpdated: null,

  params: []
};

/*
* This reducer user for create or edit calibration form
* In create case calibration info is null
*/
export default function calibration(state = initialState, action) {
  switch (action.type) {
    case 'GET_CALIBRATION_START':
      return { ...state,
        ...{ pending: true }
      };
    case 'GET_CALIBRATION_COMPLETE':
      return { ...state, ...{
        pending: false,

        recorderId: action.payload.response.recorderId || null,
        recorderName: action.payload.response.recorderName || null,

        id: action.payload.response.id || null,
        name: action.payload.response.name || null,
        dtCreated:action.payload.response.dtCreated || null,
        dtUpdated: action.payload.response.dtUpdated || null,

        params: action.payload.response.params || []
      }};
    case 'GET_CALIBRATION_PARAMS_START':
      return { ...state,
        ...{ pending: true }
      };
    case 'GET_CALIBRATION_PARAMS_COMPLETE':
      return { ...state, ...{
        pending: false,

        recorderId: action.payload.response.recorderId || null,
        recorderName: action.payload.response.recorderName || null,

        id: null,
        name: null,
        dtCreated: null,
        dtUpdated: null,

        params: action.payload.response.params || []
      }};
    default:
      return state;
  }
}
